import { render, staticRenderFns } from "./menuitemhighlighted.vue?vue&type=template&id=bde96ffe&"
import script from "./menuitemhighlighted.vue?vue&type=script&lang=js&"
export * from "./menuitemhighlighted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde96ffe')) {
      api.createRecord('bde96ffe', component.options)
    } else {
      api.reload('bde96ffe', component.options)
    }
    module.hot.accept("./menuitemhighlighted.vue?vue&type=template&id=bde96ffe&", function () {
      api.rerender('bde96ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Header/menuitemhighlighted.vue"
export default component.exports